<template>
  <div>
    <!-- 新精选课程 -->
    <!-- 以下注释都是联调时需要的 所以暂时保留！ -->
    <li class="dkillItem">
      <!--   参与秒杀的产品展示   -->
      <div v-if="item.promotionLabel && [2, 3].includes(item.promotionLabel)" class="seckill_tag">
        <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/seckill/seckill_tag.png" />
      </div>
      <p class="dkillTitle" :class="{ 'seckill-title': item.promotionLabel && [2, 3].includes(item.promotionLabel) }"
        @click="enterDetails(item)">
        <i v-if="item.name && item.name.substr(0, 1) == '【'"></i>{{ item.name }}
      </p>
      <div class="activityTag">
        <TagComponent v-for="(tagItem, tagIndex) in (item.discountLabelList || [])" :key="tagIndex" :text="tagItem"
          :color="['套餐', '电子书'].includes(tagItem) ? 'blue' : 'yellow-no-bg'" />
        <!-- 试听 -->
        <div class="audition" v-if="item.isExistsAudition === 1" @click.stop="enterLive(item)">
          试听 <img src="@/assets/img/loginImg/vidIcon.png" />
        </div>
      </div>
      <div class="TimeHours" @click="enterDetails(item)">
        <p class="Time" v-if="item.startTime">
          开课时间<span>{{ item.startTime | changeDeadLineTime }}</span><em>|</em>
        </p>
        <p class="time1"
          v-if="(item?.isEbook) && item.productAttributeRespVOS.filter(item => item.extendAttributeName === '字数')?.[0].dataJson">
          <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/player/ebook_icon.png" /> {{
            item.productAttributeRespVOS.filter(item => item.extendAttributeName === '字数')?.[0].dataJson}}
        </p>
        <p class="hourse" v-if="item.classPeriod && !item?.isEbook">
          课时<span>{{ item.classPeriod }}</span>
        </p>
      </div>

      <!-- 教师头像 -->
      <ol class="teacherList" @click="enterDetails(item)">
        <ul v-if="item.teacherRespVOS">
          <li v-for="(teacherItem, teaind) in item.teacherRespVOS.length > 3
            ? item.teacherRespVOS.slice(0, 3)
            : item.teacherRespVOS" :key="teaind">
            <div class="teabg">
              <img :src="teacherItem.teacherHead || defaultImg" alt="" />
            </div>
            <p>{{ teacherItem.name }}</p>
          </li>
        </ul>
        <div>
          <!-- 售价 -->
          <!-- 砍价展示 -->
          <div v-if="courseBarGainInfo(item) || courseBarGainInfo(item) === 0" class="coursePrice">
            <del>￥{{ item.productDiscountRespVO?.bargainActivityDetail?.sellPrice }}</del>
            <span class="courseType">砍后价</span>

            <p class="showPic">
              <template>
                <b>¥</b>
                <span>{{ courseBarGainInfo(item) }}</span>
              </template>
            </p>
          </div>
          <!-- 砍价不是最低价 -->
          <div v-else>
            <!--    参与秒杀的价格展示    -->
            <div v-if="item.promotionLabel && [2, 3].includes(item.promotionLabel)" class="seckill_price">
              <img class="icon" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/seckill/miaosha_icon.png" />
              <p><b>¥</b><span class="seckill_price_sellPrice">{{ item.sellPrice }}</span></p>
              <del v-if="coursePriceDel(item)">￥{{ item.originalPrice }}</del>
            </div>
            <!--    不参与秒杀的价格展示    -->
            <div v-else class="coursePrice">
              <del v-if="coursePriceDel(item)">￥{{ item.originalPrice }}</del>
              <span class="courseType"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">拼团价</span>
              <span v-else-if="item.promotionLabel" class="courseType">{{
                item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'
              }}</span>
              <p class="showPic">
                <template v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">
                  <b>¥</b>
                  <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
                </template>
                <template v-else>
                  <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
                  <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                    item.sellPrice === 0 && !item.promotionLabel ? '限时免费' : item.sellPrice
                  }}</span>
                </template>
              </p>
            </div>
          </div>

        </div>
      </ol>
      <div class="dkillCardBto">
        <p class="endTime">{{ item.salesVolume }}人已购买</p>
        <div class="consultBtn" @click="openChat(item)">立即咨询</div>
      </div>
    </li>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import TagComponent from '@/components/commonComponents/TagComponent.vue';
import defaultImg from '../../assets/img/loginImg/default.png';

export default {
  components: {
    TagComponent,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultImg,
    };
  },
  methods: {
    // 划线价格展示
    coursePriceShow(item) {
      return (item.productDiscountRespVO.isGroupDiscount || item.promotionLabel) ? item.sellPrice : item.originalPrice;
    },
    // 是否展示划线价
    coursePriceDel(item) {
      return item.productDiscountRespVO.isGroupDiscount || item.promotionLabel;
    },
    courseBarGainInfo(item) {
      const { productDiscountRespVO } = item
      const { discountMinPrice, bargainActivityDetail } = productDiscountRespVO || {}
      const { id, sellPrice, ladderList = [] } = bargainActivityDetail || {}
      const { accumulateCut = 0 } = ladderList[ladderList.length - 1] || {}
      // console.log(ladderList,sellPrice , accumulateCut, discountMinPrice, '????????????????????????//')
      // console.log(item, '????????????????????????//')

      return (id && (sellPrice - accumulateCut) <= discountMinPrice) ? (sellPrice - accumulateCut) : null
    },
    // 进入详情
    enterDetails(courseInfo) {
      const { productSkipConfigRespVO, productId } = courseInfo;
      const { query } = this.$route;
      console.log('enterDetails-hot', {
        courseInfo,
        query
      })
      // 判断是否App
      if (this.$root.$data.isApp) {
        if (productSkipConfigRespVO?.source === 1 && productSkipConfigRespVO?.skipType === 0) {
          // 外部产品
          this.$sendToApp('openBrowser', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else if (
          // 淘宝产品
          productSkipConfigRespVO?.source === 1 &&
          productSkipConfigRespVO?.skipType === 1
        ) {
          this.$sendToApp('openTaobao', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else {
          this.$sendToApp('goCourseDetail', Number(productId), false);
        }
        return;
      }
      if (productSkipConfigRespVO?.source === 1) {
        // 外部产品
        window.open(productSkipConfigRespVO?.mobileSkipUrl);
        return;
      }
      const { roomId } = this.$route.query;
      if (roomId) {
        // 直播间内的推荐课程
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            liveRoomId: roomId,
            beforePageName: 6,
          },
        });
        // window.open(`${window.location.origin}/ark/courseDetail?courseId=${productId}&liveRoomId=${roomId}&beforePageName=6`)
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            ...query,
            courseId: productId,
            beforePageName: 6,
          },
        });
      }
    },
    // 进入直播间
    enterLive(item) {
      if (this.$root.$data.isApp) {
        // App
        this.$sendToApp(
          'goTrialCoursePage',
          {
            courseId: item.productId,
            productCurriculumId: item.containCurriculumId,
            courseName: item.name,
          },
          false,
        );
      } else {
        const { query } = this.$route;
        sessionStorage.setItem('back', true);
        this.$router.push({
          path: '/courseDetail',
          query: {
            miniSource: query.miniSource,
            courseId: item.productId,
          },
        });
        // this.$refs.dialogComponent.show = true;
      }
    },
    openChat(item) {
      // baseBusinessLine: 1 考研 2 专升本 3 高考 4 大题库
      if (this.$root.zxMini) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(`https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6a153e1910c0770001b8a1ba`)}&probeId=${'6a153e1910c0770001b8a1ba'}`,
        });
        return;
      }
      const { baseBusinessLine } = item;
      const isZhuanShenBen = (baseBusinessLine && baseBusinessLine === 2);
      const { path } = this.$route;
      if (['/productList', '/recommendList'].includes(path)) {
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'openNewWebView',
            {
              url: `https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${isZhuanShenBen ? '689c3a62315a260001ee54f5' : '67653f7524f8c40001158e7f'}`,
            },
            false,
          );
          return;
        }
        if (this.$root.miniprogram) {
          wx.miniProgram.navigateTo({
            url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(`https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=$7926&mpid=${isZhuanShenBen ? '689c3a67bfb7e10001e38006' : '67653f9d9d78140001e5277b'}`)}&probeId=${isZhuanShenBen ? '689c3a67bfb7e10001e38006' : '67653f9d9d78140001e5277b'}`,
          });
          return;
        }
        window.open(
          `https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${isZhuanShenBen ? '689c3a62315a260001ee54f5' : '67653f7524f8c40001158e7f'}`,
        );
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: `https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${isZhuanShenBen ? '689c3a62315a260001ee54f5' : '6194a29668991d6b4e202137'}`,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(`https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=$7926&mpid=${isZhuanShenBen ? '689c3a67bfb7e10001e38006' : '653226552fe9da000198710c'}`)}&probeId=${isZhuanShenBen ? '689c3a67bfb7e10001e38006' : '653226552fe9da000198710c'}`,
        });
        return;
      }
      window.open(
        `https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${isZhuanShenBen ? '689c3a62315a260001ee54f5' : '6194a29668991d6b4e202137'}`,
      );
    },
  },
  filters: {
    changeDeadLineTime(value) {
      return value.split(' ')[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.dkillItem {
  margin-bottom: 32px;
  padding: 20px 29px 16px 25px;
  background: $bgWhite;
  border-radius: 16px;
  box-shadow: 0 2px 9px 0 #eee;
  position: relative;

  .seckill_tag {
    width: 112px;
    height: 40px;
    background: #FFD759;
    border-radius: 0px 16px 0px 16px;
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    line-height: 0px;

    img {
      width: 88px;
      height: 28px;
      margin-top: 6px;
    }
  }

  .seckill_price {
    width: auto;
    position: absolute;
    right: 0;
    bottom: 5px;
    height: 76px;
    background: linear-gradient(180deg, #FF6128 0%, #FF1F00 100%);
    border-radius: 24px;
    line-height: 0px;
    box-sizing: border-box;
    padding-left: 20px;
    padding-top: 10px;
    padding-right: 126px;

    .icon {
      position: absolute;
      width: 104px;
      height: 76px;
      top: 0;
      right: -1px;
    }

    p {
      line-height: 0px;
      height: 28px;
      margin-top: 2px;
    }

    b {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 28px;
      margin-left: 4px;
    }

    .seckill_price_sellPrice {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 28px;
      color: #FFFFFF;
      display: inline-block;
      height: 28px;
    }

    del {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: rgba(247, 248, 252, .5);
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-decoration-line: line-through;
    }
  }
}

.dkillTitle {
  display: -webkit-box;
  overflow: hidden;
  color: $fontColorBlack;
  font-weight: bold !important;
  font-size: 33px;
  line-height: 45px;
  @extend .ellipsis-2;

  // text-overflow: ellipsis;
  // -webkit-line-clamp: 2;
  // -webkit-box-orient: vertical;
  i {
    margin-left: -18px;
  }
}

.seckill-title {
  padding-right: 100px;
}

.activityTag {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 9px 5px 11px 0;
  font-size: 0;

  .tag-component {
    margin-right: 14px;
  }
}

.TimeHours {
  display: flex;
  align-items: center;
  line-height: 30px;

  p {
    margin-right: 14px;
    color: $fontColorGray;
    font-size: 24px;
  }

  .time1 {
    display: flex;
    align-items: flex-start;
    align-items: center;
    margin-right: 14px;
    color: $fontColorGray;
    font-size: 24px;

    img {
      width: 24px;
      margin-right: 5px;
    }
  }

  span {
    margin-left: 12px;
    color: $fontColorGray;
    font-size: 24px;
  }

  em {
    margin-left: 12px;
    font-style: normal;
  }
}

.teacherList {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 46px;

  ul {
    display: flex;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // width: 64px;
      margin-right: 34px;

      .teabg {
        width: 63px;
        height: 63px;
        background-color: $teabg;
        border-radius: 50%;
      }

      img {
        width: 63px;
        height: 63px;
        border-radius: 50%;
      }

      p {
        max-width: 120px;
        margin-top: 9px;
        overflow: hidden;
        color: $fontColorGray;
        font-size: 22px;
        line-height: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

.coursePrice {
  position: absolute;
  right: 0;
  bottom: 5px;
  display: flex;
  align-items: baseline;

  del {
    margin-right: 11px;
    color: $delcolor;
    font-size: 24px;
  }

  .courseType {
    color: $redColor;
    font-weight: 500;
    font-size: 24px;
  }
}

.showPic {
  margin-left: 6px;
  font-weight: bold;
  font-size: 28px;
  text-align: center;

  b {
    margin: 0 4px;
    color: $redColor;
    font-size: 28px;
  }

  span {
    color: $redColor;
    font-weight: bold;
    font-size: 38px;
  }

  .fontSty {
    font-size: 30px;
  }
}

.dkillCardBto {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  padding-top: 20px;
  border-top: 2px solid rgba(151, 151, 151, 0.1);
  zoom: 1;
}

.audition {
  position: absolute;
  top: 0;
  right: -37px;
  display: flex;
  align-items: center;
  padding: 8px 14px 8px 18px;
  color: $liveColor;
  font-weight: 500;
  font-size: 24px;
  background: #fef5f1;
  border-radius: 19px 0 0 19px;

  img {
    width: 14px;
    height: 24px;
    margin-left: 10px;
  }
}

.endTime {
  float: right;
  color: $fontColorGray;
  font-size: 24px;

  span {
    color: $fontColorGray;
    font-size: 24px;
  }
}

.consultBtn {
  width: 128px;
  height: 46px;
  color: #fff;
  font-weight: 400;
  font-size: 24px;
  line-height: 46px;
  text-align: center;
  background: #ff7f41;
  border-radius: 23px;
}
</style>
